if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

      this.validateQtyRules();
      if(this.querySelector("a")){
        this.querySelector("a").addEventListener("click", (e) => {
          e.preventDefault()
          this.change_quantity(0)
        })
      }
    }
    connectedCallback() {
      this.classList.add('buttons_added');
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }

      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      // connectedCallback()
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-featured-image');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(image);
        });
      });
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('mouseover', function () {

          // [].forEach.call(swatch_list, function (el) {
          //   el.classList.remove('active');
          // });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }

          // swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          // window.location.href = this.dataset.href;
          $(swatch).addClass("active").siblings().removeClass("active")
          evt.preventDefault();
          const prouctcard = $(this).closest(".product-card")
          const handle = prouctcard.attr("data-handle");
          const product = products_infos_variants_images[handle]
          const p_media = product?.p_media ?? []
          if(product && p_media.length > 0){
            const activeColorVal = $(this).attr("data-variant-item-value")
          
            let colorOptionIndex = false;
            (product?.s_options ?? [])?.forEach((item, idx) => {
                const nameL = item?.toLowerCase()
                if(nameL?.includes("color") || nameL?.includes("colour") || nameL?.includes("couleur") || nameL?.includes("farbe")){
                    colorOptionIndex = idx+1;
                    return;
                }
            })

            let images = [];
            let alts = [];

            if(activeColorVal){

              const p_variants = product?.p_variants ?? []

              const newImages = []
              let featured_media_id = null
              let featured_medias = {}

              p_variants?.forEach((item, idx) => {
                  featured_medias[item?.featured_media?.id] = true
                  if(item?.["option"+colorOptionIndex] == activeColorVal){
                      featured_media_id = item?.featured_media?.id
                  }
              })
              let start = false
              for(let i = 0; i < p_media?.length; i++){
                  const item = p_media[i]
                  if(item?.id == featured_media_id && !start){
                      start = true
                  }
                  if(start){
                      if(!featured_medias[item?.id] || item?.id == featured_media_id){
                          newImages.push(item?.preview_image?.src)
                          alts.push(item?.alt || "")
                      }else {
                          if(featured_media_id != item?.id){
                              break;
                          }
                      }
                  }
              }
              // console.log(newImages)
              images = newImages
            }

            prouctcard.find("a[href]").attr("href", this.dataset.href);
            const variantID = this?.dataset?.href?.split("?variant=")?.[1] ?? null;
            if(variantID){
              prouctcard.find(".product-card--add-to-cart-button").attr("data-product-id", variantID)
            }
            if(images.length > 0){
              const count = images.length
              const swiper = $(`<slider-swiper class="swiper swiper-product-card swiper-gallery" data-total-slides="${count}" data-imgs="${images.join(",")}" data-preload-imgs="${images.join(",")}"
                  data-images-loading="" data-img-alts="${alts.join(",")}" data-loop="true" data-autoplay="false" data-hover-autoplay="false"
                  data-autoplay-speed="0.0" data-enable-navigation="true" data-pagination-type="bullets" style="--total-slides: ${count};">
                  <ul class="swiper-wrapper">
                      <li id="card__product-image--1" data-swiper-slide-alt="" class="card__product-image swiper-slide aspect-ratio">
                        <img src="${images[0]}" alt="${alts[0] ?? ""}" draggable="false" class="swiper-lazy">
                      </li>
                  </ul>
                  <div class="swiper-pagination swiper-pagination--hidden" data-desktop-type="bullets" data-mobile-type="bullets"></div>
                </slider-swiper>`)

                prouctcard.find(`.card-product__media-wrapper`).css(`--total-slides`, count)

                const prev = `<div class="swiper-button-prev swiper-button swiper-button-prev-${prouctcard.attr("data-section-id")} ">
                  <span class="icon icon--small">${prouctcard.find(`.swiper-product-card`).find('.swiper-button-prev span').html()}</span>
                </div>`
                const next = `<div class="swiper-button-next swiper-button swiper-button-next-${prouctcard.attr("data-section-id")} ">
                  <span class="icon icon--small">${prouctcard.find(`.swiper-product-card`).find('.swiper-button-next span').html()}</span>
                </div>`
                swiper.append(prev, next)
                prouctcard.find(`slider-swiper`).replaceWith(swiper)

              // prouctcard.find(`.swiper-product-card`).attr(`data-imgs`, images.join(`,`))
              // prouctcard.find(`.swiper-product-card`).attr(`data-preload-imgs`, images.join(`,`))
              // prouctcard.find(`.swiper-product-card`).attr(`data-img-alts`, alts.join(`,`))
              // prouctcard.find(`.swiper-product-card`).attr(`data-total-slides`, images.length)
              // prouctcard.find(`.swiper-product-card`).attr(`style`, `--total-slides:${images.length}`)
              const slider = prouctcard.find(`.swiper-product-card`)
              if(slider[0]){
                // slider[0].dispatchEvent(new CustomEvent('swiper:update', {
                //   detail: {
                //     currentAlt: activeColorVal,
                //     index: index,
                //     arr: images,
                //     alts: alts
                //   }
                // }))
                initializeSwiper(slider[0])
                slider[0].dispatchEvent(new CustomEvent('swiper:update', {
                  detail: {
                    index: 0,
                    currentAlt: "all"
                  }
                }))
                // slider[0].style.setProperty('--total-slides', images.length);
                // slider[0].dataset.initialized = false
                // slider[0].dispatchEvent(new CustomEvent('swiper:destroy', {
                //   detail: {
                //     index: 1
                //   }
                // }))
              }
              // let imgELS = $("<div>")
              // for(let i = 0; i < images.length; i++){
              //   imgELS.append(`<img class="no-blur product-primary-image image-view-${i} ${i == 0 ? "active" : ""} product-image-view" width="2000" height="2000" data-sizes="auto" src="${images[i]}" data-srcset="${images[i]}" sizes="313px" srcset="${images[i]}">`)
              // }
              // prouctcard.find(".slider__img").html(imgELS.html())
              // window.generateProductCardSlider(prouctcard.find(".thb_slider_list"))
            }
          }

        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      // if (this.quick_add.disabled) {
      //   return;
      // }
      console.log(this.quickAdd)
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));

      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
      }

    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function ProductCardSmall
 */
if (!customElements.get('product-card-small')) {
  class ProductCardSmall extends HTMLElement {
    constructor() {
      super();

      this.quick_add_enabled = this.classList.contains('quick-add-to-card--true');
      this.button = this.querySelector('button');
      this.id = this.dataset.id;
      this.url = this.dataset.url;
    }
    connectedCallback() {
      if (this.quick_add_enabled) {
        this.setEventListeners();
      }
    }
    setEventListeners() {
      this.button?.addEventListener('click', this.addToCart.bind(this));
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }

    addToCart() {
      this.button.classList.add('loading');
      if (!this.quick_add_enabled) {
        // quick view
      }
      this.button.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.id);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.button.classList.remove('loading');
          this.button.removeAttribute('aria-disabled');
        });
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));
      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card-small', ProductCardSmall);
}

/**
 *  @class
 *  @function PanelClose
 */
class PanelClose extends HTMLElement {

  constructor() {
    super();
    let cc = document.querySelector('.click-capture');

    // Add functionality to buttons
    this.addEventListener('click', (e) => this.close_panel(e));
    document.addEventListener('keyup', (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          document.querySelectorAll('.side-panel').forEach((panel) => {
            if (document.body.classList.contains('open-cc--product')) {
              document.body.classList.remove('open-cc--product');

              setTimeout(() => {
                document.querySelector('#Product-Drawer-Content').innerHTML = '';
              }, 260);
            } else {
              if (panel.classList.contains('cart-drawer')) {
                document.getElementById('cart-drawer-toggle').focus();
              }
              document.body.classList.remove('open-cc');
              document.body.classList.remove('overflow-hidden');
            }
            panel.classList.remove('active');
          });
        }
      }
    });
    cc.addEventListener('click', (e) => {
      let panel = document.querySelector('.side-panel.active');
      if (panel) {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
        document.body.classList.remove('overflow-hidden');
      }
    });
  }

  close_panel(e) {
    e.preventDefault();
    let panel = e.target.closest('.side-panel');
    panel.classList.remove('active');
    if (document.body.classList.contains('open-cc--product')) {
      document.body.classList.remove('open-cc--product');
      setTimeout(() => {
        document.querySelector('#Product-Drawer-Content').innerHTML = '';
      }, 260);
    } else {
      document.body.classList.remove('open-cc');
      document.body.classList.remove('overflow-hidden');
    }

    document.body.classList.remove('overflow-hidden');
  }
}
customElements.define('side-panel-close', PanelClose);

/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      let button = document.getElementById('cart-drawer-toggle');


      // Add functionality to buttons
      button?.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('open-cc');
        // this.classList.add('active');
        document.querySelector("#Cart-Drawer").open()
        this.focus();
        // dispatchCustomEvent('cart-drawer:open');
      });

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.removeProductEvent();
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {
      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.target.dataset.index, '0');

          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          this.removeProductEvent();
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });
          this.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
        });
    }
    open() {
      document.body.classList.add('open-cc');
      this.classList.add('active');
      dispatchCustomEvent('cart-drawer:open');
      document.body.classList.add("overflow-hidden");
    }
    refresh() {
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.removeProductEvent();
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll(".thb-widget-title.collapsible").forEach((button) => {
      button.addEventListener("click", (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function CustomSelect
 */
if (!customElements.get('custom-select')) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();
      this.detailsements = {
        form: this.closest('form'),
        input: this.querySelector('input'),
        button: this.querySelector('.custom-select--button'),
        panel: this.querySelector('.custom-select--list'),
      };
      this.autoClose = this.dataset.autoClose;
      this.detailsements.button.addEventListener('click', this.toggleSelector.bind(this));
      this.detailsements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.detailsements.panel.querySelectorAll('button').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.detailsements.button.setAttribute('aria-expanded', 'false');
      this.classList.remove('custom-select--active');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.detailsements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.detailsements.input.value = event.currentTarget.dataset.value;
      this.detailsements.input.dispatchEvent(new Event('change'));
      this.detailsements.button.querySelector('.custom-select--text').textContent = event.currentTarget.textContent;
      if (this.detailsements.form) {
        this.detailsements.form.dispatchEvent(new Event('input'));
      }
      if (this.autoClose) {
        this.classList.remove('custom-select--active');
      }
    }

    toggleSelector(event) {
      event.preventDefault();
      this.classList.toggle('custom-select--active');
      if (this.classList.contains('custom-select--active')) {
        this.detailsements.button.focus();
        this.detailsements.button.setAttribute('aria-expanded', (this.detailsements.button.getAttribute('aria-expanded') === 'false').toString());
      } else {
        this.hidePanel();
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.classList.contains('custom-select--button');
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('custom-select', CustomSelect);
}
/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('input[name="locale_code"], input[name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
          e.preventDefault();
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      if(!this.content){
        this.content = this.querySelector('.collapsible__content')
      }
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

  }
  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        this.classList.add('product-recommendations--loaded');
        scrollableContentCM(this)

      })
      .catch(e => {
        console.error(e);
      });
  }
  connectedCallback() {
    this.fetchProducts();
  }
}

customElements.define('product-recommendations', ProductRecommendations);


// scrollable contents 
function scrollableContentCM(element){
   if(!element || !element?.classList?.contains("scrollable-content-cm")){
    return
   }

   const scrollableContainer = element.querySelector(".scrollable-content-main");
   const items = scrollableContainer.querySelectorAll(':scope > div, :scope > li');
   if(items.length == 0){
    return
   }

   const nav = document.createElement("div")
   nav.classList.add("snap-slider-nav")

   const prevButton = document.createElement("button")
   prevButton.classList.add(`nav__button-prev`)
   prevButton.innerHTML = `<span aria-label="Previous">‹</span>`

   const nextButton = document.createElement("button")
   nextButton.classList.add(`nav__button-next`)
   nextButton.innerHTML = `<span aria-label="Next">›</span>`

   nav.appendChild(prevButton)
   nav.appendChild(nextButton)

   element.appendChild(nav)

   function updateButtons() {
      prevButton.disabled = current_index === 0;
      nextButton.disabled = current_index + visibleItemsCount >= items.length;
  }
    let itemWidth, visibleItemsCount;
    let current_index = 0;

    const genearteWidth = () => {
      itemWidth = items[0]?.offsetWidth;  
      visibleItemsCount = Math.floor(scrollableContainer.offsetWidth / itemWidth);
      updateButtons();
    }
    genearteWidth()


    window.onresize = () => {
      debounce(() => {
        genearteWidth()
      }, 300)
    }

  //  function setCurrentItems() {
  //       items.forEach(item => item.classList.remove("is-current"));
  //       for (let i = current_index; i < current_index + visibleItemsCount && i < items.length; i++) {
  //           items[i].classList.add("is-current");
  //       }
  //   }

   function scrollToItem(index) {
    const offset = index * itemWidth; 
      scrollableContainer.scrollTo({
          left: offset,
          behavior: 'smooth'
      });
  }

  prevButton.addEventListener("click", () => {
      if (current_index > 0) {
          // current_index -= visibleItemsCount;
          current_index--;
          // setCurrentItems();
          scrollToItem(current_index);
          updateButtons();
      }
  });

  nextButton.addEventListener("click", () => {
      if (current_index + visibleItemsCount < items.length - 1) {
          // current_index += visibleItemsCount; 
          current_index++;
          // setCurrentItems();
          scrollToItem(current_index);
          updateButtons();
      }
  });


  const setActiveItem = debounce(() => {
      items.forEach((item) => item.classList.remove("is-active"));
      const scrollLeft = scrollableContainer.scrollLeft;
      const closestIndex = Math.round(scrollLeft / itemWidth);
      if (items[closestIndex]) {
          items[closestIndex].classList.add("is-active");
      }
      current_index = closestIndex;
      updateButtons();
  }, 100)


  scrollableContainer.addEventListener("scroll", () => {
      setActiveItem();
  });

  // setCurrentItems();
  updateButtons();
}


window.generateWishlistCount = () => {

  let wishlistCount = 0;
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('wishlist-handles');
    if (recentIds && typeof (recentIds) !== undefined) {
      try {
        wishlistCount = JSON.parse(recentIds)?.length
      } catch (error) {
      }
    }
  }
  document.querySelectorAll('.item-count-wishlist').forEach((item) => {
    item.textContent = (wishlistCount > 0 ? wishlistCount : "")
  })
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture--product');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.cc.addEventListener('click', this.setupCCEventListener.bind(this));

    }
    setupCCEventListener(e) {
      this.body.classList.remove('open-cc--product');
      this.drawer.classList.remove('active');

      setTimeout(() => {
        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = '';
      }, 260);

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        window.active_quick_view = {};
        if(window.products_infos_variants_images[this.dataset.productHandle]){
          const item = window.products_infos_variants_images[this.dataset.productHandle]?.p_products
          window.active_quick_view = {product: item, id: item?.id}
        }
        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);



        this.body.classList.add('open-cc--product');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          let slider = this.drawer.querySelector('#Product-Slider');

          slider.reInit();
          window.dispatchEvent(new Event('resize'));
        }, 100);

        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });

        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

if (!customElements.get('wishlist-button')) {
  class WishlistButton extends HTMLElement {
      constructor() {
          super();
          this.key = 'wishlist-handles';
          this.handle = this.dataset.handle;
          this.button = this.querySelector('button');
          this.button?.addEventListener('click', this.onButtonClick.bind(this));

          let prevHandles = [];
          try {
            prevHandles = JSON.parse(localStorage.getItem("wishlist-handles")) ?? []
          } catch (error) {
          }
          const handleIndex = prevHandles.findIndex((h) => h === this.handle);
          if(handleIndex > -1){
            this.toggleState(true)
          }
      }

      toggleHanlde(handle, isc) {
        try {
          let prevHandles = [];
          try {
            prevHandles = JSON.parse(localStorage.getItem("wishlist-handles")) ?? []
          } catch (error) {
          }
          const handleIndex = prevHandles.findIndex((h) => h === handle);
          
          if (handleIndex > -1) {
            prevHandles.splice(handleIndex, 1);
          } else {
            prevHandles.push(handle);
          }
          localStorage.setItem("wishlist-handles", JSON.stringify(prevHandles));
          this.toggleState(handleIndex < 0, isc)
        } catch (error) {
        }
      }

      onButtonClick(event) {
          event.preventDefault();
          this.toggleHanlde(this.handle, true)
      }

      isInWishlist() {
          const handles = localStorage.getItem(this.key);
          if (!handles) return false;
          return handles.split(',').includes(this.handle);
      }

      toggleState(isAdded, isc) {
        if(isAdded){
          this.classList.add('active')
          if(isc){
            document.querySelector("#wishlist-Drawer").open()
          }
        }else {
          this.classList.remove('active')
          const $is_wishlistPage = $(this).closest('wishlisted-products')
          if($is_wishlistPage.length > 0){
            $(this).closest('li').remove()
            if($is_wishlistPage.find(`li:not(.loading-overlay)`).length < 1){
              $('.no-wishlist-message').show()
            }
          }
        }
        if(isc){
          document.querySelector("#wishlist-Drawer wishlisted-products").open() 
        }
        window.generateWishlistCount()
      }
  }

  customElements.define('wishlist-button', WishlistButton);
}


/**
 *  @class
 *  @function AnimatedMarkers
 */
class AnimatedMarkers {

  constructor() {
    this.markers = document.querySelectorAll('.svg-marker path');
    this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';

    if (this.animations_enabled && this.markers.length) {
      this.setupEventListeners();
    }
  }
  setupEventListeners() {
    this.markers.forEach((marker, i) => {
      gsap.from(marker, {
        duration: 1,
        ease: 'power4.inOut',
        drawSVG: "0%",
        scrollTrigger: {
          trigger: marker,
          start: 'top 70%',
          end: 'bottom 80%'
        }
      });
    });
  }

}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {

  if (typeof AnimatedMarkers !== 'undefined') {
    new AnimatedMarkers();
  }
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});


var modalItem = (title, content, onClose, className) => {
  $modal = $(`<div class="modal-slide modal-sm modal--slide-up-m _inner-scroll ${className}">
      <div data-role="focusable-start" tabindex="0"></div>
      <div class="modal-inner-wrap">
          <div class="modal-header">
              <div class="modal-title">${title}</div>
              <button class="action-close" type="button">
                  <span>Close</span>
              </button>
          </div>

          <div class="modal-content">

          </div>

      </div>    
  </div>`)
  const $overlay = $(`<div class="modal-click-capture--product"></div>`)

  const close = () => {
      $overlay.remove()
      $modal.removeClass("_show")
      setTimeout(() => {
          $modal.remove()
      }, 300);
      if(typeof onClose == "function"){
          onClose()
      }
      $("body").removeClass("overflow-hidden")
  }
  $overlay.on("click", () => {
      close()
  })
  $modal.find(".action-close").on("click", () => {
      close()
  })

  $modal.find(".modal-content").html(content)

  $("body").append($modal, $overlay).ready(() => {
      $("body").addClass("overflow-hidden")
      $modal.addClass("_show")
  })

  return { closeFunc: close}
}

$(document).ready(function() {
  $("body").on("click", ".price-range-popup-opener", function() {

    const minPrice = $(this).attr('data-minprice')
    const mainPrice = $(this).attr('data-minprice')
    const maxPrice = $(this).attr('data-maxprice')
    

    const content = `<div class="infos">
        <div>
            <div class="info-title">
                Preisspanne des Produkts
            </div>
            <div>
                <p>Der angezeigte Preis gibt Ihnen eine Orientierung, liegt jedoch innerhalb einer flexiblen Preisspanne. Je nach individuellen Anpassungen kann der Endpreis variieren.</p>
                <p>Diese Spanne ergibt sich aus den verschiedenen Auswahlmöglichkeiten, die Sie für dieses Produkt haben. Der finale Preis richtet sich nach den gewählten Materialien, insbesondere der Stein- und Metallart. Unser Ziel ist es, Ihnen maximale Flexibilität zu bieten, damit Sie eine Auswahl treffen können, die sowohl Ihrem Stil als auch Ihrem Budget entspricht.</p>
            </div>
        </div>

        <div>
            <div class="info-title">Einflussfaktoren auf den Preis:</div>
        </div>

        <div>
            <div class="info-title">1. Steintypen</div>
            <div>
                <p>Sie haben die Möglichkeit, zwischen verschiedenen Steinen zu wählen – von Diamanten über Edelsteine bis hin zu Halbedelsteinen. Die jeweiligen Materialwerte beeinflussen die Preisgestaltung entsprechend.</p>
            </div>
        </div>

        <div>
            <div class="info-title">2. Metallarten</div>
            <div>
                <p>Ebenso können Sie das Metall individuell bestimmen. Ob Gold, Silber oder Platin – die Wahl des Metalls trägt entscheidend zur Preisstruktur bei.</p>
                <p>-</p>
                <p>Der niedrigste Preis innerhalb der Spanne bezieht sich in der Regel auf Kombinationen mit preisgünstigeren Materialien wie Halbedelsteinen und Silber. Der höchste Preis umfasst hingegen hochwertige Varianten, beispielsweise Diamanten in Verbindung mit Platin.</p>
                <p>Bitte beachten Sie, dass die angegebene Preisspanne eine Orientierungshilfe ist. Der genaue Preis wird im Bestellprozess berechnet und angezeigt, sobald Sie Ihre individuellen Anpassungen vorgenommen haben.</p>
            </div>
        </div>

        <div>
            <div class="info-title">Rabatte und Aktionen</div>
            <div>
                <p>Gelegentlich bieten wir exklusive Rabattaktionen an. Diese sind nicht unmittelbar in den angegebenen Preisen oder der dargestellten Preisspanne berücksichtigt. Falls eine Rabattaktion aktiv ist, kann der reduzierte Preis beim Bezahlvorgang angewendet werden – entweder durch automatische Berücksichtigung oder durch die Eingabe eines Gutscheincodes.</p>
                <p>Bitte beachten Sie, dass diese Angebote nur während spezieller Aktionszeiträume gültig sind.</p>
            </div>
        </div>
    </div>`
    modalItem("Preisspanne", content)
  })

  $("body").on("click", ".multicolumn__column.mobile-tab .tab-head", function() {
    const el = $(this).closest(".multicolumn__column.mobile-tab")
    if(el.attr("open")){
      el.removeAttr("open")
    }else {
      el.attr("open", true)
    }
  })

  $("body").on("click", ".desktop-view-crossell-open", function() {
    $(this).closest('.cart-drawer').addClass("upsell-open-transition")
    $(this).closest('.cart-drawer').toggleClass("upsell-open")
    setTimeout(() => {
      $(this).closest('.cart-drawer').removeClass("upsell-open-transition")
    }, 400);
  })




  function equalizeOwlItemHeights() {
    let maxHeight = 0;
    $('.video-carousel-wrapper .owl-carousel .owl-item').css('height', 'auto').each(function() {
        let height = $(this).outerHeight();
        if (height > maxHeight) maxHeight = height;
    });
    $('.video-carousel-wrapper .owl-carousel .owl-item').css('height', maxHeight + 'px');
  }
  $('.video-carousel-wrapper .owl-carousel').on('initialized.owl.carousel', function() {
    equalizeOwlItemHeights();
  });
  $(window).on('resize', function() {
    equalizeOwlItemHeights();
  });

  $(".owl-carousel").each(function() {
    const nav = $(this).attr("data-nav") == "false" ? false : true ?? true
    $(this).owlCarousel({
      responsive:{
          0:{
              items:$(this).attr('data-mobile') ?? 2
          },
          600:{
              items:$(this).attr('data-tab') ?? 2
          },
          1000:{
              items:$(this).attr('data-desktop') ?? 2
          }
      },
      slideBy: "page",
      margin:10,
      // nav:$(this).attr('data-dots') ?? false,
      nav: nav
    });
  })
  // $("body").on("click", ".owl-nav .owl-prev", function(e) {
  //   e.preventDefault()
  //   $(this).closest(".owl-carousel").find(".owl-dot.active").prev().trigger("click")
  // })
  // $("body").on("click", ".owl-nav .owl-next", function(e) {
  //   e.preventDefault()
  //   $(this).closest(".owl-carousel").find(".owl-dot.active").next().trigger("click")
  // })

  $("body").on("click", ".video-carousel-wrapper video", function() {
    const $button = $(this).siblings(".play-button");;
    const video = $(this).get(0);
    video.pause();
    // video.currentTime = 0;
    $button.show();
  })
  $("body").on("click", ".video-c-container .play-button", function () {
    const $button = $(this);
    const $video = $button.siblings("video");
    const video = $video.get(0);
    if (video) {
      if(video.paused){
        video.play().then(res => {
          console.log(res)
        });
        $button.hide();
      }else {
        $button.show();
      }
      $video.off("ended").on("ended", function () {
        video.pause();
        // video.currentTime = 0;
        $button.show();
      });
    }
  });

  $("body").on("click", ".wrapper_product_view_selected .image-view", function() {
    let index = $(this).attr('data-imgps') ?? 1;
    index = parseInt(index)
    $(`.product-image-view.image-view-${index}`).addClass("active").siblings().removeClass("active")
    $(this).closest("li").addClass("selected").siblings().removeClass("selected")
    
    $(`.product-image-view.image-view-${index}`).each(function(){
      $(this).closest(".thb_slider_list").attr('data-index', index).trigger("change")
    })
  })

  $("body").on('change', '#modell_view_toggler', function() {
    let index = $(this).is(":checked") ? 1 : 0;
    $(`.swiper-product-card`).each(function(){
       this.dispatchEvent(new CustomEvent('swiper:update', {
        detail: {
          // currentAlt: currentAlt,
          index: index
        }
      }));
    })
    //   $(`.product-image-view.image-view-${index}`).each(function(){
    //   $(this).closest(".thb_slider_list").attr('data-index', index).trigger("change")
    // })
  })

  $("body").on("click", ".times-list .opening-hours__label", function() {
    $(this).closest(".times-list").toggleClass("open")
  })

  $("body").on("click", `[data-click="close"]`, function() {
    $("#search-modal-full").removeClass("active")
    $("body").removeClass("overflow-hidden");
  })

  $("body").on("click", `[data-click="close"]`, function() {
    $("#search-modal-full").removeClass("active")
    $("body").removeClass("overflow-hidden");
  })
  $('body').on("click", "#header-search-input-small, .thb-secondary-area-item.thb-quick-search", function(e) {
    e.preventDefault();
    $("#search-modal-full").addClass("active")
    $("body").addClass("overflow-hidden");
    $("#header-search-input").trigger("focus")
  })

  // slider
  window.generateProductCardSlider = ($this) => {
    const $wrapper = $this.children('.slider__img')
    const $item = $this.children('.slider__img').children(".product-image-view").first()
    const $prev = $this.children(".nav__button-prev")
    const $next = $this.children(".nav__button-next")
    const total = $this.children('.slider__img').children("img").length - 1
    const active = (to, is_direct, smooth = true) => {
      let index = is_direct ? parseInt(to) : parseInt(($this.attr("data-index") ?? 0)) + to
      index = index > total ? 0 : index < 0 ? total : index
      const itemWidth = $item.outerWidth(true);
      const offset = (index) * itemWidth; 
      $wrapper.get(0).scrollTo({
          left: offset,
          behavior: smooth ? "smooth" : 'instant'
      });
      $this.attr("data-index", index)
      $this.find(`.item-dot-parent[data-index="${index}"]`).addClass("is-current").siblings().removeClass("is-current")
    }
    $this.off("change").on('change', function() {
      // console.log($this.attr("data-index"))
      active($this.attr("data-index"), true, false)
    })

    const $dots = $this.find('.snap-slider-dot')
    $dots.html("")
    if(total + 1 > 1){
      for(let i = 0; i < total + 1; i++){
        const $dot = $(`<div class="item-dot-parent ${i == 0 ? `is-current` : ""}" data-index="${i}">
          <span class="item-dot child only-child main-dot">
            <span class="icon"></span>
          </span>
        </div>`)
        // $dot.on("click", function(){
        //   active(i)
        // })
        $dots.append($dot)
      }  
      $dots.off("click").on("click", ".item-dot-parent", function() {
        active($(this).attr("data-index"), true)
      })
  
      $prev.off("click").on("click", function() {
        active(-1)
      })
      $next.off("click").on("click", function() {
        active(1)
      })
    }else {
      $prev.remove()
      $next.remove()
    }
  }
  $(".thb_slider_list").each(function() {
    window.generateProductCardSlider($(this))
  })


  $("body").on("click", `.category-tab-filter [data-role="collapsible"]`, function() {
    $(`#${$(this).attr("aria-controls")}`).show().siblings(`[data-role="content"]`).hide()
    $(this).addClass('active').siblings(`[data-role="collapsible"]`).removeClass("active")
  })

  window.generateWishlistCount()


  $('#wishlist-drawer-toggle').on("click", function(e) {
    document.querySelector("#wishlist-Drawer").open()
  })

})



function shopifyFormatCurrency(cents) {
  const placeholderRegex = /{{\s*(\w+)\s*}}/;

  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
      if (isNaN(number) || number == null) {
          return "0";
      }

      const numString = (number / 100.0).toFixed(precision);
      const parts = numString.split(".");
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      const cents = parts[1] ? decimal + parts[1] : "";
      return dollars + cents;
  }

  const formatString = '{{amount_with_comma_separator}}€'
  if (!formatString) {
      return cents / 100
  }

  return formatString.replace(placeholderRegex, (match, placeholder) => {
      switch (placeholder) {
          case "amount":
              return formatWithDelimiters(cents, 2);
          case "amount_no_decimals":
              return formatWithDelimiters(cents, 0);
          case "amount_with_comma_separator":
              return formatWithDelimiters(cents, 2, ".", ",");
          case "amount_no_decimals_with_comma_separator":
              return formatWithDelimiters(cents, 0, ".", ",");
          case "amount_with_apostrophe_separator":
              return formatWithDelimiters(cents, 2, "'", ".");
          case "amount_no_decimals_with_space_separator":
              return formatWithDelimiters(cents, 0, " ");
          case "amount_with_space_separator":
              return formatWithDelimiters(cents, 2, " ", ",");
          case "amount_with_period_and_space_separator":
              return formatWithDelimiters(cents, 2, " ", ".");
          default:
              return match;
      }
  });
}

function initializeSwiper(slider) {
    if (slider.dataset.initialized === 'true') return;
    slider.dataset.initialized = 'true';
    let speed = parseInt(slider.dataset.transitionDuration, 10) || 300;
    let autoplaySpeed = parseInt(slider.dataset.autoplaySpeed, 10) || 5000;
    let autoplay = slider.dataset.autoplay === "true";
    let loop = slider.dataset.loop === "true";
    let slidesLoaded = false;
    let direction
    let isDragging
    let cardSwiper;
    function initSwiper() {
        const slideShow = $(slider).closest("slide-show").length > 0
        cardSwiper = new Swiper(slider, {
            a11y: {
                slideRole: 'listitem'
            },
            slidesPerView: 1,
            loop: loop,
            pagination: {
                el: slider.querySelector('.swiper-pagination'),
                type: 'bullets'
            },
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            },
            speed: speed,
            autoplay: autoplay,
            lazy: {
                loadPrevNext: true,
            },
            roundLengths: false,
            allowTouchMove: !slideShow, 
            simulateTouch: !slideShow,
            on: {
                touchStart(swiper, e) {
                    e.stopPropagation();
                },
                touchMove: function (_, e) {
                    e.stopPropagation()
                    setTimeout(() => {
                        isDragging = true;
                    }, 0);
                },
                touchEnd: function (_, e) {
                    e.stopPropagation()
                    setTimeout(() => {
                        isDragging = false;
                    }, 0);
                }
            }
        });
    }
    initSwiper();

    function loadAllSlides(slider, index) {
        if (!slider.classList.contains('swiper-loaded')) slider.classList.add('swiper-loaded')
        const totalSlides = parseInt(slider.dataset.totalSlides, 10);
        const productImages = slider.getAttribute('data-imgs').split(',');
        const productImageAlts = slider.getAttribute('data-img-alts').split(',');
        let imagesLoading = ''
        let preloadImages
        slider.querySelector('.swiper-wrapper').innerHTML = ""
        if (slider.hasAttribute('data-images-loading')) {
            imagesLoading = slider.getAttribute('data-images-loading');

            preloadImages = slider.getAttribute('data-preload-imgs')?.split(',');
        }
        if (imagesLoading == '' || imagesLoading == 'fade_scale' || imagesLoading == 'loader' || imagesLoading == 'disable') isSlideReady = true;
        for (let i = index; i < totalSlides; i++) {
            let image = productImages[i];
            let alt = productImageAlts[i];
            let preloadImage
            if (imagesLoading !== '' && preloadImages.length > 0) preloadImage = preloadImages[i];
            let newSlide = document.createElement("li");
            newSlide.classList.add('card__product-image', 'swiper-slide', 'aspect-ratio');
            if (imagesLoading != '' && imagesLoading != 'fade_scale') {
                newSlide.innerHTML = `<figure class="lazy-image lazy-image--${imagesLoading}"><div class="lazy-image__preloader lazy-image__preloader--full lazy-image__preloader-${imagesLoading}" aria-hidden="true"><img src="${preloadImage}" loading="eager" width="10" height="10" alt="${alt}"></div><img src="${image}" loading="lazy" onload="this.parentNode.classList.add('lazyloaded');" alt="${alt}"></figure>`;
            } else if (imagesLoading == 'fade_scale') {
                newSlide.innerHTML = `<figure class="lazy-image lazy-image--${imagesLoading}"><img src="${image}" loading="lazy" onload="this.parentNode.classList.add('lazyloaded');" alt="${alt}"></figure>`;
            } else {
                newSlide.innerHTML = `<img src="${image}" alt="${alt}">`;
            }

            slider.querySelector('.swiper-wrapper').append(newSlide);
            if (imagesLoading !== '' && imagesLoading !== 'fade_scale' && imagesLoading !== 'loader') {
                const preloadImg = newSlide.querySelector('.lazy-image__preloader img');
                if (preloadImg) {
                    isSlideReady = false;
                    if (preloadImg.complete) {
                        isSlideReady = true;
                        if (pendingSlide === 'next') {
                            cardSwiper.slideNext();
                        } else if (pendingSlide === 'prev') {
                            cardSwiper.slidePrev();
                        }
                        pendingSlide = null;
                    } else {
                        preloadImg.addEventListener('load', () => {
                            isSlideReady = true;
                            if (pendingSlide === 'next') {
                                cardSwiper.slideNext();
                            } else if (pendingSlide === 'prev') {
                                cardSwiper.slidePrev();
                            }
                            pendingSlide = null;
                        });
                    }
                }
            }
        }
        cardSwiper.update()
        recreateSwiper();

        if (window.innerWidth > 768 && autoplay) {
            slider.addEventListener('mouseenter', () => {
                cardSwiper.params.autoplay = {
                    delay: autoplaySpeed,
                    disableOnInteraction: false
                };
                cardSwiper.autoplay.start()
            });
            slider.addEventListener('mouseleave', () => {
                if (cardSwiper.autoplay.running) cardSwiper.autoplay.stop()
            })
        }
    }

    if (window.innerWidth > 768 && autoplay) {
        slider.addEventListener('mouseenter', () => {
            cardSwiper.params.autoplay = {
                delay: autoplaySpeed,
                disableOnInteraction: false
            };
            cardSwiper.autoplay.start()
        });
        slider.addEventListener('mouseleave', () => {
            if (cardSwiper.autoplay.running) cardSwiper.autoplay.stop()
        })
    }

    function loadAllSlidesByVariant(slider, currentAlt, swatchImageIndex, arr, alts) {
        if (!slider.classList.contains('swiper-loaded')) slider.classList.add('swiper-loaded')
        const sliderWrapper = slider.querySelector('.swiper-wrapper');
        const productImages = slider.getAttribute('data-imgs').split(',');
        const productImageAlts = slider.getAttribute('data-img-alts').split(',');

        sliderWrapper.innerHTML = '';

        const appendSlide = (image, alt = '') => {
            const newSlide = document.createElement("li");
            newSlide.classList.add('card__product-image', 'swiper-slide', 'aspect-ratio');
            newSlide.innerHTML = `<img src="${image}" alt="${alt}"><div class="swiper-lazy-preloader"></div>`;
            sliderWrapper.append(newSlide);
        };

        // let filteredImages = productImages
        //     .map((image, index) => ({ image, alt: productImageAlts[index] }))
        //     .filter(({ alt }) => alt.includes(currentAlt));

        // if (filteredImages.length === 0) {
        //     if (swatchImageIndex !== undefined && productImages[swatchImageIndex]) {
        //         filteredImages = [{ image: productImages[swatchImageIndex], alt: productImageAlts[swatchImageIndex] }];
        //     } else {
        //         filteredImages = productImages.map((image, index) => ({ image, alt: productImageAlts[index] }));
        //     }
        // }

        for(let i = 0; i < arr.length; i++){
          appendSlide(arr[i].image, alts[i])
        }
        // arr.forEach(({ image, alt }) => appendSlide(image, alt));

        recreateSwiper();
        slider.style.setProperty('--total-slides', sliderWrapper.children.length);
    }

    function recreateSwiper() {
        if (cardSwiper) {
            cardSwiper.destroy(true, true);
            cardSwiper = null
        }
        initSwiper();
    }

    if (slider.querySelector('.swiper-button-next')) slider.querySelector('.swiper-button-next').addEventListener('click', () => {
        if (!slidesLoaded) {
            loadAllSlides(slider, index = 1);
            slidesLoaded = true;
        }
        if (isSlideReady) {
            cardSwiper.slideNext();
        } else {
            pendingSlide = 'next';
        }
    });

    if (slider.querySelector('.swiper-button-prev')) slider.querySelector('.swiper-button-prev').addEventListener('click', (e) => {
        e.preventDefault();
        if (!slidesLoaded) {
            loadAllSlides(slider, index = 1);
            slidesLoaded = true;
        }
        if (isSlideReady) {
            cardSwiper.slidePrev();
        } else {
            pendingSlide = 'prev';
        }
    });

    if (slider.querySelector('.swiper-button-next')) slider.querySelector('.swiper-button-next').addEventListener('keyup', (e) => {
        if (e.code.toUpperCase() === 'ENTER') {
            if (!slidesLoaded) {
                loadAllSlides(slider, index = 1);
                slidesLoaded = true;
            }
            if (isSlideReady) {
                cardSwiper.slideNext();
            } else {
                pendingSlide = 'next';
            }
        }
    });

    if (slider.querySelector('.swiper-button-prev')) slider.querySelector('.swiper-button-prev').addEventListener('keyup', (e) => {
        if (e.code.toUpperCase() === 'ENTER') {
            e.preventDefault();
            if (!slidesLoaded) {
                loadAllSlides(slider, index = 1);
                slidesLoaded = true;
            }
            if (isSlideReady) {
                cardSwiper.slidePrev();
            } else {
                pendingSlide = 'prev';
            }
        }
    });

    cardSwiper.on('sliderFirstMove', () => {
        const diffX = cardSwiper.touches.currentX - cardSwiper.touches.startX;
        const diffY = cardSwiper.touches.currentY - cardSwiper.touches.startY;
        if (Math.abs(diffX) > Math.abs(diffY)) {
            diffX > 0 ? direction = 'right' : direction = 'left'
        }
        if (!slidesLoaded) {
            loadAllSlides(slider, index = 1);
            slidesLoaded = true;
        }

        if (isSlideReady) {
            direction === 'left' ? cardSwiper.slideNext(300) : cardSwiper.slidePrev(300);
        } else {
            pendingSlide = direction === 'left' ? 'next' : 'prev';
        }
    });

    if (autoplay) slider.addEventListener('mouseenter', () => {
        if (!slidesLoaded) {
            loadAllSlides(slider, index = 1);
            slidesLoaded = true;
        }
    });
    slider.closest('.card').addEventListener('click', (e) => {
        if (isDragging) e.preventDefault();
    });
    slider.addEventListener('swiper:destroy', (event) => {
      recreateSwiper()
    })
    slider.addEventListener('swiper:update', (event) => {
        const sliderWrapper = slider.querySelector('.swiper-wrapper');

        if (event.detail.currentAlt === 'all') {
            sliderWrapper.innerHTML = '';
            loadAllSlides(slider, index = 0);
        } else {
            loadAllSlidesByVariant(slider, event.detail.currentAlt, event.detail.index, event.detail.arr ?? [], event.detail.alts ?? []);
        }

        slidesLoaded = true;

        if (!slider.querySelector('.swiper-wrapper-only-variant')) {
            let variantFirstImageIndex = event.detail.index;

            if (!variantFirstImageIndex) {
                const productImageAlts = slider.getAttribute('data-img-alts').split(',');
                variantFirstImageIndex = productImageAlts.findIndex(alt => alt.includes(event.detail.currentAlt));
            }

            sliderWrapper.innerHTML = '';
            loadAllSlides(slider, index = 0);
            cardSwiper.slideTo(variantFirstImageIndex || 0, 0);
        }
    });
}

// window.onload = () =>{ 
  let sliders = document.querySelectorAll('.swiper-product-card');
  sliders.forEach(initializeSwiper);
// }